import { Injectable } from "@angular/core";
import { fetchAuthSession, fetchUserAttributes, signOut } from 'aws-amplify/auth';
@Injectable({
    providedIn: 'root'
})
export class AmplifyAuthService {

    constructor() {}

    signOut() {
        return signOut()
    }
    fetchUserAttributes() {
        return fetchUserAttributes()
    }
    fetchAuthSession() {
        return fetchAuthSession()
    }
}